import { createReducer } from '@reduxjs/toolkit';

import { loadersBuilder, errorBuilder, logoutBuilder } from '@modules/builders';

import sellActions from './actions';
import initialState from './state';
import type * as SellTypes from './types';

export const sellReducer = createReducer(initialState, builder => {
  builder.addCase(sellActions.clearErrors, state => {
    state.errors = {};
  });

  loadersBuilder('sell', builder);
  logoutBuilder(initialState, builder);
  errorBuilder('sell', builder);
});

export { sellActions, SellTypes };
